// src/components/RequestStatus/RequestStatus.js
import { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { useCallback } from "react";
import axios from "axios";
// Importing each tab content component
import PendingLeaves from "../RequestStatus/PendingLeaves";
import ApprovedLeaves from "../RequestStatus/ApprovedLeaves";
import NotApprovedLeaves from "../RequestStatus/NotApprovedLeaves";
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

export default function RequestStatus() {
  const [key, setKey] = useState("pending");
  const [error, setError] = useState("");
  const [allData, setAllData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  // This function will be passed to both components
  const fetchApprovedRequests = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const res = await axios.get(`${API_URL}/api/approved-requests`);
      const arr = Array.isArray(res.data) ? res.data : [];
      const sorted = arr.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
      setAllData(sorted);
      setData(sorted);
      setCurrentPage(1);
    } catch (err) {
      setError("Failed to load approved requests");
    } finally {
      setLoading(false);
    }
  }, []);


  return (
    <div className="px-2 px-md-4 py-3" style={{ minHeight: "100vh", height: "100%" }}>
      <div className="underline-tabs">
        <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="flex-nowrap">
          <Tab eventKey="pending" title="Pending">
            <PendingLeaves fetchApprovedRequests={fetchApprovedRequests} />
          </Tab>
          <Tab eventKey="approved" title="Approved">
            <ApprovedLeaves
              fetchApprovedRequests={fetchApprovedRequests}
              setAllData={setAllData}
              setData={setData}
              loading={loading}
              data={data}
              error={error}
              allData={allData}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </Tab>
          <Tab eventKey="notApproved" title="Rejected">
            <NotApprovedLeaves />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}
